import path from 'node:path';
import { getBridgeRoot } from './cwd/index.js';

/** Resolve a path under cwd; returns null if it escapes the working directory. */
export function ensureUnderCwd(relativePath: string, cwd: string = getBridgeRoot()): string | null {
  const normalized = path.normalize(relativePath).replace(/^(\.\/)+/, '');
  const resolved = path.resolve(cwd, normalized);
  if (!resolved.startsWith(cwd + path.sep) && resolved !== cwd) {
    return null;
  }
  return resolved;
}
